import React, {useEffect, useRef} from "react"
import {useNavigate} from "react-router-dom"
import {useTranslation} from "react-i18next"
import {useAuth} from "../hooks/useAuth"
import {appRoute} from "../utils/routes"
import LoadingPageComponent from "../components/Loading/LoadingPageComponent"

/**
 * Landing page on the app subdomain for a session started on the guest site (see
 * `AuthContext.appEntryUrl`): signs in with the token from the URL fragment, then opens the
 * requested page. Without a usable token it falls back to the login page.
 */
const Continue = () => {
    const auth = useAuth()
    const navigate = useNavigate()
    const {t} = useTranslation()
    // StrictMode runs effects twice; the token is already cleared from the URL by the second run.
    const started = useRef(false)

    useEffect(() => {
        if (started.current) return
        started.current = true

        const params = new URLSearchParams(window.location.hash.slice(1))
        const token = params.get("token")
        const next = params.get("next") || ""
        // Keep the token out of the history and out of anything that later reads the URL.
        window.history.replaceState(null, "", window.location.pathname)

        if (!token) {
            navigate("/login", {replace: true})
            return
        }

        // Only paths inside the app, never another site.
        const safeNext = next.startsWith("/") && !next.startsWith("//") ? next : ""
        auth.signInWithHandoffToken(token)
            .then(signedIn => navigate(signedIn ? appRoute(safeNext) : "/login", {replace: true}))
    }, [])

    return <LoadingPageComponent loadingText={t("plainLoadingText")}/>
}

export default Continue
